module.exports = __webpack_public_path__ + "static/quiz2_4-bebb029005ef60c7ef764bc709ca1c31.png";